import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { analytics } from 'core/analytics';

import { html } from 'libs/editor/serializers/html';
import { EditorStore } from 'libs/editor/store';
import { Editor } from 'libs/editor';
import DocumentHead from 'legacyComponents/documentHead';
import { HeaderMarginTop as Main, Divider } from 'legacyComponents/styled/lib';
import { clientStore } from 'apps/client/app';
import { imageSrc } from 'apps/file/utils';
import Like from 'apps/content/views/like';

import { Button } from 'components';
import { TagLinks } from 'apps/story/views/tagLinks';
import { AuthorDetails } from 'apps/story/views/authorDetails';
import { StoryInfo } from 'apps/story/views/storyInfo';
import { Comments } from 'apps/story/views/comments';
import { StoryIndicator } from 'apps/story/views/storyIndicator';
import { StoryWrapper, Title, Article, CoverImage } from 'apps/story/styles';

import Header from 'apps/components/header/header';

import { conf as mainConf } from 'apps/config.yaml';
import i18next from 'i18next';

@observer
export class StoryView extends React.Component {
  constructor(props) {
    super(props);
    analytics.sendEvent('ViewContent', {}, { twitter: true, facebook: true });
    analytics.linkedinPixel('1169129');
  }

  onClickSignUp = () => {
    clientStore?.routerStore?.navigate('home.signUp', {
      next: clientStore?.next(),
    });
  };

  render() {
    const { story, params, loading } = this.props;
    const shouldShowStartFreeTrail = !clientStore.signedInProfile;

    if (loading || !story) {
      return (
        <main>
          <Header />
          <StoryIndicator />
        </main>
      );
    }
    const { avatar, title } = story;
    const src = imageSrc(
      avatar,
      story.imageFallbackPath,
      mainConf.imgSizes.story.large,
    );
    // FIXME - look into avoiding store creation during render
    const store = new EditorStore({
      initialValue: html.deserialize(story.body || '<p></p>'),
      formatting: 'advanced',
    });

    return (
      <Main>
        <Header />
        <DocumentHead
          title={`${title} by ${story.spacePath}`}
          description={story.bodySnippet}
          imagePath={imageSrc(story.avatar)}
        />
        <CoverImage src={src} key='image' alt={title} />
        <Article>
          <Title>{title}</Title>
          <StoryInfo story={story} />
          <StoryWrapper margin='25px auto 0 auto'>
            <Editor store={store} />
          </StoryWrapper>
          <TagLinks tags={story.tags} />
          <Like content={story.content} />
          <Divider width='100%' margin='20px auto 0px auto' />
        </Article>
        <AuthorDetails story={story} />

        {shouldShowStartFreeTrail ? (
          <div className=' flex-center h-[31.25rem]  relative w-full bg-black'>
            <div className='flex-y-center h-full w-full bg-[url(/assets/marketplace/Get-started-Wikifactory.webp)] bg-center bg-no-repeat'>
              <div className='flex-y-center text-white w-[31.75rem] gap-8'>
                <p className=' text-6xl text-center font-helvetica-xbold text-white leading-[4.5rem] font-bold'>
                  {i18next.t('Get started with Wikifactory today')}
                </p>
                <p className=' text-[1.3125rem] mb-4  text-center text-white'>
                  {i18next.t(
                    'Let’s shape the future of product development, together',
                  )}
                </p>
                <Button
                  onClick={this.onClickSignUp}
                  data-testid='StoryPage-start-a-free-trail-button'
                  text={i18next.t('Start a Free Trial')}
                  className='font-helvetica-xbold text-xl'
                  style={{
                    width: '16.875rem',
                    height: '4.125rem',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '99999px',
                    fontSize: '1.25rem',
                  }}
                />
              </div>
            </div>
          </div>
        ) : (
          <>
            <Comments hideAction story={story} params={params} />
          </>
        )}
      </Main>
    );
  }
}

StoryView.propTypes = {
  story: PropTypes.object,
  params: PropTypes.object,
  loading: PropTypes.bool,
};
